import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default from 'react';

var useIsOverflowing = function useIsOverflowing(ref) {
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOverflowing = _React$useState2[0],
    setIsOverflowing = _React$useState2[1];
  for (var _len = arguments.length, deps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    deps[_key - 1] = arguments[_key];
  }
  React__default.useEffect(function () {
    if (ref.current) {
      setIsOverflowing(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [].concat(deps));
  return isOverflowing;
};

export { useIsOverflowing };
